import React from 'react';
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';
import MobileBottomNav from '@components/layout/MobileBottomNav';
import { PAGE_SCHEMAS, SEOHead, SEO_META_TAGS, useSEO } from '@/seo';

// Global layout components
import BackgroundLayer from '@components/layout/Background/BackgroundLayer';

// Page-specific components
import HeroSection from './components/HeroSection';
import DestinationSection from './components/DestinationSection';
import ServicesSection from './components/ServicesSection';
import GuidanceSection from './components/GuidanceSection';
import PricingSection from './components/PricingSection';
import DiscussionsSection from './components/DiscussionsSection';
import FAQSection from './components/FAQSection';

const Landing: React.FC = () => {
  return (
    <>
      <div className="min-h-screen bg-cosmic-950 text-primary-50 selection:bg-secondary-500/30 selection:text-white font-sans pb-16 md:pb-0">
        {/* SEO Meta Tags */}
        <SEOHead
          {...useSEO(SEO_META_TAGS.landing.English, 'English')}
          structuredData={PAGE_SCHEMAS.landing}
        />

        <BackgroundLayer />
        <Header />

        <main>
          <HeroSection />
          <DestinationSection />
          <ServicesSection />
          <GuidanceSection />
          <PricingSection />
          <DiscussionsSection />
          <FAQSection />
        </main>

        <Footer />
      </div>

      {/* Mobile Bottom Navigation - Outside main container for fixed positioning */}
      <MobileBottomNav />
    </>
  );
};

export default Landing;
